"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Config = void 0;

var Interfaces_1 = require("../Interfaces");

var Config =
/** @class */
function () {
  function Config() {}

  Config.isProdEnv = function (env) {
    return env === Interfaces_1.Env['prod-us'] || env === Interfaces_1.Env['prod-apac'];
  };

  Config.getBasePaymentUrl = function (env) {
    switch (env) {
      case Interfaces_1.Env['prod-us']:
        return 'https://us.public.payments.fast.asurion.com/v1';

      case Interfaces_1.Env['prod-apac']:
        return 'https://ap.public.payments.fast.asurion.com/v1';

      case Interfaces_1.Env['qa-us']:
        return 'https://us.public.payments.npr.fast.asurion.com/qa';

      case Interfaces_1.Env['qa-apac']:
        return 'https://ap.public.payments.npr.fast.asurion.com/qa';

      case Interfaces_1.Env.dev:
        return 'https://us.public.payments.npr.fast.asurion.com/dev';

      case Interfaces_1.Env.local:
        return 'http://localhost:3000/v3';

      case Interfaces_1.Env['local-epaper']:
        return 'http://localhost:8001/bgw';

      case Interfaces_1.Env['dev-epaper']:
        return 'https://dev.epaper.pci.npr.aws.asurion.net/api/bgw';

      case Interfaces_1.Env['qa-epaper']:
        return 'https://qa.epaper.pci.npr.aws.asurion.net/api/bgw';

      case Interfaces_1.Env['uat-epaper']:
        return 'https://uat.epaper.pci.npr.aws.asurion.net/api/bgw';

      case Interfaces_1.Env['staging-epaper']:
        return 'https://staging.epaper.asurion53.com/api/bgw';

      case Interfaces_1.Env['prod-epaper']:
        return 'https://epaper.asurion53.com/api/bgw';

      default:
        return 'http://fakeUrl';
    }
  };

  Config.defaultTimeout = 30000; // 30 seconds

  Config.defaultVendorTimeout = 15000; // 15 seconds

  return Config;
}();

exports.Config = Config;